import { getProduct } from '#/products/domain';

export function normalize(productCode: string, quantity: number): string {
  const { quantityPrecision } = getProduct(productCode);
  const normalizeQty = (qty: number) => qty.toFixed(quantityPrecision);

  return normalizeQty(quantity);
}
